module.exports = __webpack_public_path__ + "img/raw.b3d73079.png";